import { type ReportSeverity, reportSeverities } from '@ipfabric/utils';
import type { PathInspectorPacket } from 'components/DeviceView/deviceViewTypes';

export const getPathInspectorPacketHighestSeverity = (
  packet: PathInspectorPacket,
): ReportSeverity => {
  return reportSeverities.reduce(
    (acc: ReportSeverity, severity: ReportSeverity): ReportSeverity => {
      if ((packet.severityInfo?.[severity] ?? 0) > 0) {
        return severity;
      }
      return acc;
    },
    0,
  );
};
